import { DEGREES, CATEGORIES, RANKS } from "@global/const";

export const modBlocks = {
    description: 'Информация о враче',
    education: 'Образование',
    certificates: 'Курсы и сертификаты',
    employment: 'Опыт работы',
    associations: 'Член ассоциации врачей',
}
const modFields = {
    img: {default: '', options:  {type: 'imgEdit', imgType: 'doctors', height:225, emptyImgName: 'pic_he.svg', path:'/storage.public/images/doctors/150x225/'}},
    nameFamily: {default: '', options: {type: 'text', prefix: 'Фамилия'}},
    nameFirst: {default: '', options: {type: 'text', prefix: 'Имя'}},
    nameFathers: {default: '', options: {type: 'text', prefix: 'Отчество'}},
    url: {default: '', options: {type: 'text', prefix: 'URL'}},
    degree: {default: '', options: {type: 'select', prefix: 'Степень', options: DEGREES }},
    category: {default: '', options: {type: 'select', prefix: 'Категория', options: CATEGORIES }},
    rank: {default: '', options: {type: 'select', prefix: 'Звание', options: RANKS }},
    experience: {default: '', options: {type: 'text', prefix: 'Стаж', suffix: 'лет', rules:'numeric|max_value:100|min_value:0'}},
    sex: {
        default: '', options: {
            type: 'select',
            prefix: 'Пол',
            options: [
                {value: "MALE", text: "Мужской"},
                {value: "FEMALE", text: "Женский"}
            ]
        }
    },
    specialities_ids: {default: [], options: {type: 'specialities', prefix: 'Спец'}},
    info: {default: '', options: {type: 'html', block:'description', entity: 'doctor'}},
    education: {default: '', options: {type: 'education', block:'education'}},
    certificates: {default: '', options: {type: 'certificates', block:'certificates'}},
    employment: {default: '', options: {type: 'employment', block:'employment'}},
    associations: {default: '', options: {type: 'associations', block:'associations'}},
    photos: {default: [], options: {
            type: 'photos',
            path:'/storage.public/images/doctorPhotos/120x120/',
            preset: 'photo',
            uploadUrl: '/admin/doctors/uploadPhoto',
            buttonText: 'Добавить<br>фотографии',
        }},
}

export function modDefault()
{
    return _.mapValues(modFields, function (o) {
        return o.default;
    });
}

export function modOptions()
{
    const options = [];
    Object.keys(modFields).forEach(function (key, index) {
        options[index] = modFields[key].options;
        options[index].key = key;
    })
    return options;
}

function currentYear() {
    return new Date().getFullYear() ?? 2400;
}

// export function getDictionary(name)
// {
//     let axios = require('axios');
//
//     const dict = axios.get('/dictionary/'+name, );
//     console.log('dict',dict)
//      return dict;
// }
